import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mainColor, UNIT } from '../../constants';
import LaunchingForm from '../LaunchingForm';
import IbanForm from '../IbanForm';
import Button from '../Button';
import ValidationStripeModal from '../ValidationStripeModal';
import {
  MISSED_PAYMENT_INFO,
  MISSED_SHOP_INFO,
  MISSED_STRIPE_INFO
} from '../../constants/dishopInfo';
import { setOpacity } from '../../utils/orderUtils';
import * as actions from '../../actions/index';
import { getMessageDishop } from '../../apis/backend'
const INITIAL_STATE = {
  showLaunchingModal: false,
  communications: null
};
class LaunchingPanel extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  fetchCommunications = async () => {
    try {
      const comm = await getMessageDishop();
      this.setState({ communications: comm });
    } catch (error) {
      console.error('Failed to fetch communications:', error);
    }
  };

  async componentDidMount() {
    await this.fetchCommunications();
  }

  toggleModal = (show) => {
    this.setState({ showLaunchingModal: show });
  };

  renderWarningPanel() {
    const { firebaseCompleted, customAccountId, stripeCompleted } = this.props;
    const { showLaunchingModal } = this.state;

    const panelStyle = {
      borderRadius: UNIT,
      border: '1px solid',
      borderColor: setOpacity('255, 50, 50', 0.25),
      backgroundColor: setOpacity('255, 50, 50', 0.25),
    };

    let title, buttonText;
    if (!firebaseCompleted) {
      title = MISSED_SHOP_INFO.title;
      buttonText = MISSED_SHOP_INFO.buttonText;
    } else if (!customAccountId) {
      title = MISSED_PAYMENT_INFO.title;
      buttonText = MISSED_PAYMENT_INFO.buttonText;
    } else {
      title = MISSED_STRIPE_INFO.title;
      buttonText = MISSED_STRIPE_INFO.buttonText;
    }

    return (
      <>
        <div className='d-flex flex-column mt-2 py-3 mx-4' style={panelStyle}>
          <div className='mb-0 pl-4'>
            <h5 className='bold-text' style={{ color: mainColor.colorBlack }}>
              {title}
            </h5>
          </div>
          <div className='pl-4'>
            <p style={{ color: mainColor.colorBlack }}>
              Vous devez rentrer ces informations avant de pouvoir commencer à vendre vos produits.
              <br />
              <Button
                onClick={() => this.toggleModal(true)}
                color='secondary'
                outlined
                className='btn-xs-block mt-2'
                style={{ fontSize: 12, marginTop: 8, borderRadius: 10 }}
              >
                {buttonText}
              </Button>
            </p>
          </div>
        </div>

        <LaunchingForm
          showLaunchingModal={showLaunchingModal && !firebaseCompleted}
          onClose={() => this.toggleModal(false)}
        />
        <IbanForm
          showLaunchingModal={showLaunchingModal && !customAccountId && firebaseCompleted}
          email={this.props.email}
          name={this.props.name}
          isProd={this.props.isProd}
          onClose={() => this.toggleModal(false)}
        />
        <ValidationStripeModal
          onClose={() => this.toggleModal(false)}
          showLaunchingModal={
            showLaunchingModal && !stripeCompleted && customAccountId && firebaseCompleted
          }
        />
      </>
    );
  }

  renderInfoBanner() {
    const { communications } = this.state;
    const { showModal } = this.props;
    const formatModalMessage = (message) => {
      if (!message) return '';
      return message
        .replace(/\\n/g, '\n')
        .split('\n')
        .map((line, i, arr) => (
          <React.Fragment key={i}>
            {line}
            {i < arr.length - 1 && <br />}
          </React.Fragment>
        ));
    };

    const panelStyle = {
      borderRadius: UNIT,
      border: '1px solid',
      borderColor: setOpacity('0, 153, 115', 0.25),
      backgroundColor: setOpacity('0, 153, 115', 0.25),
    };

    return (
      <div className='d-flex flex-column mt-2 py-3 mx-4' style={panelStyle}>
        <div className='mb-0 pl-4'>
          <h5 className='bold-text' style={{ color: mainColor.colorBlack }}>
            {communications?.titleBanner}
          </h5>
        </div>
        <div className='pl-4'>
          <p style={{ color: mainColor.colorBlack }}>
            {communications?.messageBanner}
            <br />
            <Button
              onClick={() => showModal({
                color: 'primary',
                title: communications?.title || '',
                message: <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '0 15px' }}>{formatModalMessage(communications?.message) || ''}</div>,
                btnTxt: 'Fermer',
                onClick: () => showModal(null),
                handleClose: () => showModal(null),
                size: 'xs',
                header: true
              })}
              style={{ fontSize: 12, marginTop: 8, borderRadius: 10 }}
              color='secondary'
              outlined
              className='btn-xs-block mt-2'
            >
              Lire la suite
            </Button>
          </p>
        </div>
      </div>
    );
  }

  render() {
    const { isAllShops, firebaseCompleted, customAccountId, stripeCompleted } = this.props;
    const { communications } = this.state;

    const showInfoBanner = communications?.activated;

    if (!isAllShops && (!firebaseCompleted || !customAccountId || !stripeCompleted)) {
      return this.renderWarningPanel();
    }

    if (showInfoBanner) {
      return this.renderInfoBanner();
    }

    return null;
  }
}
function mapStateToProps({ user, firebaseRealTime }) {
  const { isAuthenticated, isInitializing, dataHelpModal = {}, initializedApp, isAllShops } = user;
  const { link, isOpen } = dataHelpModal;
  const { shop = {}, generalConfig } = firebaseRealTime;
  const { servicePrice = {}, configuration = {}, name, support = {} } = shop;
  const { customAccountId } = servicePrice;
  const { domain } = generalConfig;
  const { email } = support;
  const { completed = {} } = configuration;
  const { stripe: stripeCompleted, firebase: firebaseCompleted } = completed;
  const isProd = domain ? !domain.includes('dev-') : false;
  return {
    isAuthenticated,
    isInitializing,
    firebaseCompleted,
    customAccountId,
    stripeCompleted,
    initializedApp,
    email,
    name,
    isProd,
    isOpen,
    link,
    isAllShops
  };
}
export default connect(mapStateToProps, actions)(LaunchingPanel);
